import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { createPortal } from 'react-dom';
import { Toast } from './Toast';
import styles from './Toast.module.scss';
export const ToastContext = React.createContext(undefined);
export const ToastProvider = ({ children, position = 'top-right', defaultDuration = 3000, }) => {
    const [toasts, setToasts] = React.useState([]);
    const timeoutRefs = React.useRef({});
    const [mounted, setMounted] = React.useState(false);
    React.useEffect(() => {
        setMounted(true);
    }, []);
    const removeToast = React.useCallback((id) => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
        if (timeoutRefs.current[id]) {
            clearTimeout(timeoutRefs.current[id]);
            delete timeoutRefs.current[id];
        }
    }, []);
    const showToast = React.useCallback((toast) => {
        const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const newToast = { ...toast, id };
        setToasts((prev) => [...prev, newToast]);
        if (defaultDuration > 0) {
            timeoutRefs.current[id] = setTimeout(() => {
                removeToast(id);
            }, defaultDuration);
        }
    }, [defaultDuration, removeToast]);
    React.useEffect(() => {
        const timeouts = timeoutRefs.current;
        return () => {
            Object.values(timeouts).forEach(clearTimeout);
        };
    }, []);
    const contextValue = React.useMemo(() => ({ showToast }), [showToast]);
    const containerClasses = [styles['toast-container'], styles[`toast-container--${position}`]]
        .filter(Boolean)
        .join(' ');
    return (_jsxs(ToastContext.Provider, { value: contextValue, children: [children, mounted &&
                createPortal(_jsx("div", { className: containerClasses, children: toasts.map((toast) => (_jsx(Toast, { message: toast.message, variant: toast.variant, noBorder: toast.noBorder, onClose: () => removeToast(toast.id) }, toast.id))) }), document.body)] }));
};
